export const DEMO_EXPERTS = [
  {
    id: 60,
    imageURL:
      'https://res.cloudinary.com/hrsvcp9vu/image/upload/c_thumb,h_500,w_500/v1691594742/production-TjoCZY/b99abf6e01818edd4a95/1691594742.jpg',
    qwotedURL: 'https://seoplus.qwoted.com/sources/brock-murray',
    name: 'Brock Murray',
    email: 'brock@seoplus.ca',
    representativeName: null,
    pointOfContactJson: '[{"id":1716455257779,"firstName":"Brock","lastName":"Murray","email":"brock@seoplus.ca"}]',
    reportsContactsJson: null,
    position: 'Co-Founder',
    company: 'seoplus+',
    positionAndCompany: 'Co-Founder at seoplus+',
    bio: 'Brock Murray is the co-founder of seoplus+ digital marketing agency. As the driving force behind this award-winning, full-service agency, Brock\'s passion is helping businesses establish, grow, and maintain their online presence. With the help of SEO, PPC, social media, content marketing, and more, Brock and his team help clients of varying sizes and verticals, from small, local retailers to large, multinational enterprise companies.',
    companyURL: 'https://seoplus.qwoted.com/companies/seoplus',
    linkedinURL:
      'https://www.linkedin.com/feed/?shareActive=true&text=Brock+Murray+%7C+Source+%7C+Chief+Operating+Officer+%26+Co-Founder+at+seoplus%2B%20https://seoplus.qwoted.com/sources/brock-murray',
    twitterURL:
      'https://twitter.com/intent/tweet?text=Brock+Murray+%7C+Source+%7C+Chief+Operating+Officer+%26+Co-Founder+at+seoplus%2B&url=https://seoplus.qwoted.com/sources/brock-murray',
    websiteURL: 'https://brock.enterprises/',
    location: 'Ottawa, ON, Canada',
    representativesJSON:
      '[{"name":"Abror Kamalov","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/abror-kamalov-a794d61f-8f10-42b4-944b-5b0b99a388bd"},{"name":"Grace Cowie (Digital PR Specialist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/grace-cowie"},{"name":"Daphne Tse (Digital PR Strategist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/daphne-tse"},{"name":"Ally Dyck (Digital PR Specialist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/ally-dyck"},{"name":"Catherine Hansen (Digital PR Manager at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/catherine-hansen"}]',
    hashtags: 'seo, digital, marketing, search, engine, optimization, geo, generative, ai, business, leadership, management, coo',
    promptModify:
      'This GPT acts as an expert in digital marketing, digital PR, SEO, paid ads, and web design. The tone should be professional, ensuring it aligns with the values of seoplus+ and is never contradictory to the brand. Depending on the topic, it can be candid, offering clear and straightforward insights while maintaining a professional demeanor.',
    valid: 0,
    isActive: 1,
  },
  {
    id: 106,
    imageURL:
      'https://res.cloudinary.com/hrsvcp9vu/image/upload/c_thumb,h_500,w_500/v1714055856/production-TjoCZY/aaacbe6fd9c4ae56f2cc/1714055856.jpg',
    qwotedURL: 'https://seoplus.qwoted.com/sources/catherine-hansen',
    name: 'Catherine Hansen',
    email: null,
    representativeName: null,
    pointOfContactJson: '[{"id":1717712449081,"firstName":"Brock","lastName":"Murray","email":"brock@seoplus.ca"}]',
    reportsContactsJson: null,
    position: 'Digital PR Manager',
    company: 'seoplus+',
    positionAndCompany: 'Digital PR Manager at seoplus+',
    bio: 'Catherine Hansen is the Digital PR Team Manager at seoplus+. She began her digital marketing career in 2019 in the social media department, progressing through roles as specialist, coordinator, and team lead before moving into Digital PR. Since 2021, she has led the department with a focus on strategy, collaboration, and growth. A dedicated advocate for empowerment and learning, Catherine is passionate about helping her clients and her team thrive and gain recognition as thought leaders in their industries.\r\n\r\nAs a member of the Canadian Public Relations Society (CPRS), a former part-time professor at Algonquin College, and the current Influence Chair and Leadership and Business Fundamental mentor at seoplus+, she champions the importance of education and professional development in both the classroom and the workplace. Her commitment to continuous learning fuels innovative strategies that have secured top-tier placements for clients in outlets such as Forbes, The Globe and Mail, The New York Times, Vogue, and Business Insider. Her emphasis on mentorship and empowerment has made her a driving force in building a collaborative, success-oriented environment, leaving a lasting impact on both her team and her clients.',
    companyURL: 'https://seoplus.qwoted.com/companies/seoplus',
    linkedinURL:
      'https://www.linkedin.com/feed/?shareActive=true&text=Catherine+Hansen+%7C+Source+%7C+Digital+PR+Manager+at+seoplus%2B%20https://seoplus.qwoted.com/sources/catherine-hansen',
    twitterURL:
      'https://twitter.com/intent/tweet?text=Catherine+Hansen+%7C+Source+%7C+Digital+PR+Manager+at+seoplus%2B&url=https://seoplus.qwoted.com/sources/catherine-hansen',
    websiteURL: 'https://seoplus.com/',
    location: 'Ottawa, ON, Canada',
    representativesJSON:
      '[{"name":"Abror Kamalov","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/abror-kamalov-a794d61f-8f10-42b4-944b-5b0b99a388bd"},{"name":"Grace Cowie (Digital PR Specialist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/grace-cowie"},{"name":"Ally Dyck (Digital PR Specialist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/ally-dyck"},{"name":"Daphne Tse (Digital PR Strategist at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/daphne-tse"},{"name":"Catherine Hansen (Digital PR Manager at seoplus+)","role":"","link":"https:\\/\\/seoplus.qwoted.com\\/pr_users\\/catherine-hansen"}]',
    hashtags:
      'seo, digital, marketing, search, engine, optimization, geo, generative, ai, public, relations, pr, comms, communications, manager, leadership, digital pr, qwoted, platform, haro, query, backlink, media',
    promptModify:
      'This GPT acts as an expert in digital marketing, digital PR, SEO, paid ads, and web design. The tone should be professional, ensuring it aligns with the values of seoplus+ and is never contradictory to the brand. Depending on the topic, it can be candid, offering clear and straightforward insights while maintaining a professional demeanor.',
    valid: 0,
    isActive: 1,
  },
  // Additional experts from different companies
  {
    id: 301,
    imageURL: 'https://ui-avatars.com/api/?name=Sarah+Chen&background=3b82f6&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/sarah-chen',
    name: 'Sarah Chen',
    email: 'sarah.chen@techvision.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435710,"firstName":"Sarah","lastName":"Chen","email":"sarah.chen@techvision.com"}]',
    reportsContactsJson: null,
    position: 'Chief Technology Officer',
    company: 'TechVision Inc',
    positionAndCompany: 'Chief Technology Officer at TechVision Inc',
    bio: 'Sarah Chen is the CTO at TechVision Inc, a leading software development company specializing in AI and machine learning solutions. With over 15 years of experience in technology leadership, Sarah has led teams in developing cutting-edge products that have revolutionized industries from healthcare to finance.',
    companyURL: 'https://techvision.example.com/',
    linkedinURL: 'https://linkedin.com/in/sarahchen',
    twitterURL: null,
    websiteURL: 'https://techvision.example.com/',
    location: 'San Francisco, CA, USA',
    representativesJSON: null,
    hashtags: 'technology, ai, machine learning, software development, cto, tech leadership, innovation',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 302,
    imageURL: 'https://ui-avatars.com/api/?name=Michael+Rodriguez&background=10b981&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/michael-rodriguez',
    name: 'Michael Rodriguez',
    email: 'mrodriguez@greenearthconsulting.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435711,"firstName":"Michael","lastName":"Rodriguez","email":"mrodriguez@greenearthconsulting.com"}]',
    reportsContactsJson: null,
    position: 'Sustainability Consultant',
    company: 'GreenEarth Consulting',
    positionAndCompany: 'Sustainability Consultant at GreenEarth Consulting',
    bio: 'Michael Rodriguez is a Sustainability Consultant at GreenEarth Consulting, specializing in helping businesses reduce their environmental impact while improving profitability. With a background in environmental science and business strategy, Michael has advised Fortune 500 companies on sustainable practices and green technologies.',
    companyURL: 'https://greenearthconsulting.example.com/',
    linkedinURL: 'https://linkedin.com/in/michaelrodriguez',
    twitterURL: null,
    websiteURL: 'https://greenearthconsulting.example.com/',
    location: 'Portland, OR, USA',
    representativesJSON: null,
    hashtags: 'sustainability, environment, green business, consulting, esg, climate change, renewable energy',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 303,
    imageURL: 'https://ui-avatars.com/api/?name=Emily+Watson&background=ec4899&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/emily-watson',
    name: 'Emily Watson',
    email: 'emily@brandcraft.agency',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435712,"firstName":"Emily","lastName":"Watson","email":"emily@brandcraft.agency"}]',
    reportsContactsJson: null,
    position: 'Creative Director',
    company: 'BrandCraft Agency',
    positionAndCompany: 'Creative Director at BrandCraft Agency',
    bio: 'Emily Watson is the Creative Director at BrandCraft Agency, an award-winning branding and design studio. She leads creative strategy for global brands, specializing in brand identity, visual storytelling, and user experience design. Her work has been featured in Communication Arts and won multiple ADDY Awards.',
    companyURL: 'https://brandcraft.example.com/',
    linkedinURL: 'https://linkedin.com/in/emilywatson',
    twitterURL: 'https://twitter.com/emilywatson',
    websiteURL: 'https://brandcraft.example.com/',
    location: 'New York, NY, USA',
    representativesJSON: null,
    hashtags: 'branding, design, creative, brand strategy, ux design, visual identity, creative director',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 304,
    imageURL: 'https://ui-avatars.com/api/?name=David+Thompson&background=f59e0b&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/david-thompson',
    name: 'David Thompson',
    email: 'david@retailgrowthstrategies.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435713,"firstName":"David","lastName":"Thompson","email":"david@retailgrowthstrategies.com"}]',
    reportsContactsJson: null,
    position: 'E-commerce Strategy Director',
    company: 'Retail Growth Strategies',
    positionAndCompany: 'E-commerce Strategy Director at Retail Growth Strategies',
    bio: 'David Thompson is an E-commerce Strategy Director at Retail Growth Strategies, helping retailers optimize their online presence and drive revenue growth. With expertise in conversion optimization, customer journey mapping, and omnichannel strategies, David has helped clients increase online sales by an average of 200%.',
    companyURL: 'https://retailgrowthstrategies.example.com/',
    linkedinURL: 'https://linkedin.com/in/davidthompson',
    twitterURL: null,
    websiteURL: 'https://retailgrowthstrategies.example.com/',
    location: 'Austin, TX, USA',
    representativesJSON: null,
    hashtags: 'ecommerce, retail, online sales, conversion optimization, customer experience, omnichannel',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 305,
    imageURL: 'https://ui-avatars.com/api/?name=Jennifer+Lee&background=8b5cf6&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/jennifer-lee',
    name: 'Jennifer Lee',
    email: 'jlee@healthtechpr.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435714,"firstName":"Jennifer","lastName":"Lee","email":"jlee@healthtechpr.com"}]',
    reportsContactsJson: null,
    position: 'Healthcare Communications Specialist',
    company: 'HealthTech PR',
    positionAndCompany: 'Healthcare Communications Specialist at HealthTech PR',
    bio: 'Jennifer Lee is a Healthcare Communications Specialist at HealthTech PR, focusing on digital health, medical technology, and pharmaceutical communications. She has worked with leading healthcare organizations to navigate complex regulatory environments while building strong media relationships and securing coverage in top-tier health publications.',
    companyURL: 'https://healthtechpr.example.com/',
    linkedinURL: 'https://linkedin.com/in/jenniferlee',
    twitterURL: null,
    websiteURL: 'https://healthtechpr.example.com/',
    location: 'Boston, MA, USA',
    representativesJSON: null,
    hashtags: 'healthcare, medical, healthtech, digital health, pharma, medical technology, health communications',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 306,
    imageURL: 'https://ui-avatars.com/api/?name=Robert+Martinez&background=ef4444&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/robert-martinez',
    name: 'Robert Martinez',
    email: 'robert@financefirst.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435715,"firstName":"Robert","lastName":"Martinez","email":"robert@financefirst.com"}]',
    reportsContactsJson: null,
    position: 'Financial Advisor',
    company: 'Finance First Advisory',
    positionAndCompany: 'Financial Advisor at Finance First Advisory',
    bio: 'Robert Martinez is a Financial Advisor at Finance First Advisory with over 12 years of experience in wealth management, retirement planning, and investment strategy. He specializes in helping individuals and families achieve their financial goals through personalized planning and market insights.',
    companyURL: 'https://financefirst.example.com/',
    linkedinURL: 'https://linkedin.com/in/robertmartinez',
    twitterURL: null,
    websiteURL: 'https://financefirst.example.com/',
    location: 'Chicago, IL, USA',
    representativesJSON: null,
    hashtags: 'finance, investment, wealth management, retirement planning, financial planning, advisor',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 307,
    imageURL: 'https://ui-avatars.com/api/?name=Lisa+Anderson&background=06b6d4&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/lisa-anderson',
    name: 'Lisa Anderson',
    email: 'lisa@hrexcellence.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435716,"firstName":"Lisa","lastName":"Anderson","email":"lisa@hrexcellence.com"}]',
    reportsContactsJson: null,
    position: 'HR Director',
    company: 'HR Excellence Group',
    positionAndCompany: 'HR Director at HR Excellence Group',
    bio: 'Lisa Anderson is the HR Director at HR Excellence Group, specializing in talent acquisition, employee engagement, and organizational development. She has helped companies across various industries build strong workplace cultures and implement effective HR strategies that drive business results.',
    companyURL: 'https://hrexcellence.example.com/',
    linkedinURL: 'https://linkedin.com/in/lisaanderson',
    twitterURL: null,
    websiteURL: 'https://hrexcellence.example.com/',
    location: 'Seattle, WA, USA',
    representativesJSON: null,
    hashtags: 'hr, human resources, talent acquisition, recruiting, employee engagement, workplace culture, organizational development',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 308,
    imageURL: 'https://ui-avatars.com/api/?name=James+Wilson&background=14b8a6&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/james-wilson',
    name: 'James Wilson',
    email: 'james@cloudninetech.io',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435717,"firstName":"James","lastName":"Wilson","email":"james@cloudninetech.io"}]',
    reportsContactsJson: null,
    position: 'Cloud Solutions Architect',
    company: 'Cloud Nine Technologies',
    positionAndCompany: 'Cloud Solutions Architect at Cloud Nine Technologies',
    bio: 'James Wilson is a Cloud Solutions Architect at Cloud Nine Technologies, helping businesses migrate to and optimize their cloud infrastructure. With certifications in AWS, Azure, and Google Cloud, James has designed scalable cloud architectures for startups and enterprises, reducing costs by up to 40% while improving performance.',
    companyURL: 'https://cloudninetech.example.com/',
    linkedinURL: 'https://linkedin.com/in/jameswilson',
    twitterURL: null,
    websiteURL: 'https://cloudninetech.example.com/',
    location: 'Denver, CO, USA',
    representativesJSON: null,
    hashtags: 'cloud computing, aws, azure, google cloud, devops, infrastructure, cloud architecture, saas',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 309,
    imageURL: 'https://ui-avatars.com/api/?name=Maria+Garcia&background=a855f7&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/maria-garcia',
    name: 'Maria Garcia',
    email: 'maria@socialimpactco.org',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435718,"firstName":"Maria","lastName":"Garcia","email":"maria@socialimpactco.org"}]',
    reportsContactsJson: null,
    position: 'Social Impact Strategist',
    company: 'Social Impact Collective',
    positionAndCompany: 'Social Impact Strategist at Social Impact Collective',
    bio: 'Maria Garcia is a Social Impact Strategist at Social Impact Collective, working with nonprofits and social enterprises to maximize their impact. She specializes in impact measurement, stakeholder engagement, and strategic planning. Maria has helped organizations raise over $50M in funding and reach millions of beneficiaries.',
    companyURL: 'https://socialimpactco.example.org/',
    linkedinURL: 'https://linkedin.com/in/mariagarcia',
    twitterURL: 'https://twitter.com/mariagarcia',
    websiteURL: 'https://socialimpactco.example.org/',
    location: 'Los Angeles, CA, USA',
    representativesJSON: null,
    hashtags: 'social impact, nonprofit, social enterprise, impact measurement, fundraising, social good, philanthropy',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 310,
    imageURL: 'https://ui-avatars.com/api/?name=Tom+Burke&background=f97316&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/tom-burke',
    name: 'Tom Burke',
    email: 'tom@cybersecuritypros.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435719,"firstName":"Tom","lastName":"Burke","email":"tom@cybersecuritypros.com"}]',
    reportsContactsJson: null,
    position: 'Cybersecurity Expert',
    company: 'CyberSecurity Pros',
    positionAndCompany: 'Cybersecurity Expert at CyberSecurity Pros',
    bio: 'Tom Burke is a Cybersecurity Expert at CyberSecurity Pros, specializing in threat detection, incident response, and security architecture. With CISSP and CEH certifications, Tom has protected organizations from cyber threats and helped them build robust security frameworks. He regularly speaks at industry conferences about emerging security trends.',
    companyURL: 'https://cybersecuritypros.example.com/',
    linkedinURL: 'https://linkedin.com/in/tomburke',
    twitterURL: null,
    websiteURL: 'https://cybersecuritypros.example.com/',
    location: 'Washington, DC, USA',
    representativesJSON: null,
    hashtags: 'cybersecurity, infosec, data protection, threat detection, security, hacking, cyber defense',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 311,
    imageURL: 'https://ui-avatars.com/api/?name=Priya+Patel&background=db2777&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/priya-patel',
    name: 'Priya Patel',
    email: 'priya@datainsightslab.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435720,"firstName":"Priya","lastName":"Patel","email":"priya@datainsightslab.com"}]',
    reportsContactsJson: null,
    position: 'Data Scientist',
    company: 'Data Insights Lab',
    positionAndCompany: 'Data Scientist at Data Insights Lab',
    bio: 'Priya Patel is a Data Scientist at Data Insights Lab, helping organizations leverage data for strategic decision-making. With expertise in machine learning, predictive analytics, and data visualization, Priya has developed models that have improved business outcomes across retail, finance, and healthcare sectors.',
    companyURL: 'https://datainsightslab.example.com/',
    linkedinURL: 'https://linkedin.com/in/priyapatel',
    twitterURL: null,
    websiteURL: 'https://datainsightslab.example.com/',
    location: 'San Jose, CA, USA',
    representativesJSON: null,
    hashtags: 'data science, machine learning, analytics, big data, predictive analytics, data visualization, ai',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 312,
    imageURL: 'https://ui-avatars.com/api/?name=Alex+Kim&background=0ea5e9&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/alex-kim',
    name: 'Alex Kim',
    email: 'alex@startupmentor.ventures',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435721,"firstName":"Alex","lastName":"Kim","email":"alex@startupmentor.ventures"}]',
    reportsContactsJson: null,
    position: 'Startup Advisor',
    company: 'Startup Mentor Ventures',
    positionAndCompany: 'Startup Advisor at Startup Mentor Ventures',
    bio: 'Alex Kim is a Startup Advisor at Startup Mentor Ventures, having founded and exited two successful SaaS companies. Alex now mentors early-stage founders on product-market fit, fundraising, and growth strategies. He has advised over 50 startups, with 15 reaching Series A funding or profitability.',
    companyURL: 'https://startupmentor.example.com/',
    linkedinURL: 'https://linkedin.com/in/alexkim',
    twitterURL: 'https://twitter.com/alexkim',
    websiteURL: 'https://startupmentor.example.com/',
    location: 'San Francisco, CA, USA',
    representativesJSON: null,
    hashtags: 'startups, entrepreneurship, venture capital, saas, product market fit, fundraising, growth hacking',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 313,
    imageURL: 'https://ui-avatars.com/api/?name=Rachel+Brown&background=84cc16&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/rachel-brown',
    name: 'Rachel Brown',
    email: 'rachel@contentfirst.media',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435722,"firstName":"Rachel","lastName":"Brown","email":"rachel@contentfirst.media"}]',
    reportsContactsJson: null,
    position: 'Content Strategist',
    company: 'Content First Media',
    positionAndCompany: 'Content Strategist at Content First Media',
    bio: 'Rachel Brown is a Content Strategist at Content First Media, specializing in B2B content marketing and thought leadership. She has developed content strategies for tech companies, SaaS providers, and professional services firms that have generated millions in pipeline value through strategic content.',
    companyURL: 'https://contentfirst.example.com/',
    linkedinURL: 'https://linkedin.com/in/rachelbrown',
    twitterURL: null,
    websiteURL: 'https://contentfirst.example.com/',
    location: 'Toronto, ON, Canada',
    representativesJSON: null,
    hashtags: 'content marketing, content strategy, b2b marketing, thought leadership, copywriting, editorial',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
  {
    id: 314,
    imageURL: 'https://ui-avatars.com/api/?name=Kevin+O+Brien&background=6366f1&color=fff&size=500',
    qwotedURL: 'https://demo.qwoted.com/sources/kevin-obrien',
    name: 'Kevin O\'Brien',
    email: 'kevin@luxurybrandgroup.com',
    representativeName: null,
    pointOfContactJson: '[{"id":1758843435723,"firstName":"Kevin","lastName":"O\'Brien","email":"kevin@luxurybrandgroup.com"}]',
    reportsContactsJson: null,
    position: 'Luxury Brand Consultant',
    company: 'Luxury Brand Group',
    positionAndCompany: 'Luxury Brand Consultant at Luxury Brand Group',
    bio: 'Kevin O\'Brien is a Luxury Brand Consultant at Luxury Brand Group, advising high-end fashion, hospitality, and lifestyle brands on market positioning and brand elevation. His expertise in luxury consumer behavior and premium brand strategy has helped clients maintain exclusivity while expanding their reach.',
    companyURL: 'https://luxurybrandgroup.example.com/',
    linkedinURL: 'https://linkedin.com/in/kevinobrien',
    twitterURL: null,
    websiteURL: 'https://luxurybrandgroup.example.com/',
    location: 'Miami, FL, USA',
    representativesJSON: null,
    hashtags: 'luxury brands, fashion, hospitality, brand positioning, premium brands, lifestyle, luxury marketing',
    promptModify: null,
    valid: 1,
    isActive: 1,
  },
];
